import { DebugControlsService, DeviceIdService } from '@pulse/browser-shared';
import { TrackerConfigurations } from '@pulse/common';
import { DebugService } from './debug.service';

export class LiveEventDebugService {
    constructor(
        private debug: DebugService,
        private debugControl: DebugControlsService,
        private config: TrackerConfigurations,
        private deviceIdService: DeviceIdService,
    ) {}

    displayControl() {
        this.debugControl.registerControl({
            control: 'debug',
            content: 'Debug mode is enabled',
            title: '',
            url: 'https://picsart.tools/organization/picsart/app/picsart-website/debugger',
            deviceId: this.deviceIdService.getDeviceId(),
            callbackFn: this.disableDebugMode.bind(this),
        });
    }

    private disableDebugMode() {
        this.debugControl.unregisterControl('debug');
        this.debug.disable('debugger');
        this.debug.disable(this.config.debugLiveEventKey);
    }
}
